import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Modal, Tab, Tabs } from 'react-bootstrap'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { CSSTransitionGroup } from 'react-transition-group'

import program from '@h2/assets/svg/icons/program.svg'
import college from '@h2/assets/svg/icons/college.svg'
import certification from '@h2/assets/svg/icons/certification.svg'
import companies from '@h2/assets/svg/icons/companies.svg'
import workBasedLearning from '@h2/assets/svg/icons/workBasedLearning.svg'

import {
  addUserPermission,
  closeSetupModal,
  closeSurveyModal,
  deleteSection,
  deleteUserPermission,
  dismissPermissions,
  finishProfileSetup,
  loadProfile,
  reorder,
  saveProfileUpdates,
  searchClusters,
  searchTags,
  selectEditModalTab,
  toggleActive,
  toggleDrag,
  toggleEditModal,
  toggleUserPermission
} from '../../actions/profileViewActions'
import { openContentWizard as openCContentWizard_ } from '../../actions/contentSnippetWizard'
import { openFileWizardModal as openCFileWizard_ } from '../../actions/fileManagementWizard'
import ProfileSetupWizard from '../../components/profiles/tutorial/ProfileSetupWizard'
import PermissionModal from '../../components/profiles/PermissionModal'
import SurveyListModal from '../../components/survey/creation/SurveyListModal'
import { openMessageDialog } from '../../actions/messageDialog'
import Form from '../../components/form/Form'
import Field from '../../components/form/Field'
import {
  closeDocumentationModal,
  openCollection,
  selectSection
} from '../../actions/documentation'
import { Documentation } from '../../components/Documentation'
import OutputSurvey from '../../components/survey/OutputSurvey'
import {
  cancelRename,
  cloneProfileSurveyAction,
  createNewSurveyForEdit,
  deleteSurveyQuestion,
  dismissEditSurveyModal,
  doRename,
  loadSurveys,
  reorderQuestion,
  respondToQuestion,
  saveNewProfileSurvey,
  saveQuestion,
  selectForRename,
  selectSurveyForEdit,
  selectSurveyQuestionForEdit,
  submitSurvey,
  unselectSurveyForEdit,
  updateSurveyName,
  validateResponse
} from '../../actions/surveys'
import * as v from '../../components/form/validations'
import { togglePromotion } from '../../actions/admin/adminCertificationActions'
import LoadingIndicator from '../../components/LoadingIndicator'

const EditForm = ({
  profile,
  profileEditError,
  clusterSuggestions,
  tagSuggestions,
  cancelAction,
  onSearchTags,
  onSearchClusters,
  saveAction
}) => {
  const formModel = 'profileForms.editForm'
  const model = path => `${formModel}.${path}`

  return (
    //.title, .url, .active
    ////dispatch(actions.searchProfiles(form))
    /*
     *<div className="nav" style={{marginTop: "1em"}}>
     *      <input type="submit" className="submit" value="Submit"/>
     *      <button type="button" onClick={cancelAction} className="cancel">Cancel</button>
     *
     *  </div>
     */

    <Form
      model={formModel}
      onSubmit={form => {
        saveAction(form)
      }}>
      {form => (
        <div>
          {profileEditError && (
            <div className={'alert alert-danger'}>
              {t`An error occurred while updating the form.`}
            </div>
          )}

          <Field
            model={model(`title`)}
            largeTextInput={true}
            required={true}
            label={t`Name`}
            type="text"
            form={form}
          />

          <Field
            model={model(`url`)}
            form={form}
            largeTextInput={true}
            validate={[v.url()]}
            label={t`URL`}
            type="text"
          />

          <Field model={model(`active`)} form={form} label={t`Active`} type="checkbox" />

          <Field
            model={model(`tags`)}
            form={form}
            label={t`Tags`}
            type="MultiSelect"
            options={tagSuggestions.result.map(r => {
              return {
                label: r.label,
                value: {
                  name: r.label,
                  tagId: r.value
                }
              }
            })}
            onSearchChange={() => onSearchTags(profile.type, profile.id)}
            createFromValue={values => {
              return values.map(v => {
                return { label: v.name, value: v }
              })
            }}>
          </Field>

          {dynamicValues.userProfile?.isRoot && (
            <Field
              model={model(`subTenant`)}
              label={t`Sub Tenant`}
              type="SimpleSelect"
              options={[{ label: t`Root`, value: { id: 'none', name: t`Root` } }].concat(
                dynamicValues.tenants
                  .find(t => t.id === dynamicValues.tenantId)
                  .subTenants.map(v => {
                    return {
                      label: v.name,
                      value: v
                    }
                  })
              )}
              form={form}
              renderOption={option => {
                return (
                  <div style={{ padding: '1em' }}>
                    <b>{option.label}</b>
                  </div>
                )
              }}
              createFromSearch={() => null}
              createFromValue={value => ({ label: value.name, value })}>
            </Field>
          )}

          <div className="nav" style={{ marginTop: '1em' }}>
            <input type="submit" className="submit btn no-style" value={t`Submit`} />
            <button type="button" onClick={cancelAction} className="cancel btn no-style">
              {t`Cancel`}
            </button>
          </div>
        </div>
      )}
    </Form>
  )
}
const ProfileHeader = ({
  dispatch,
  editingEnabled,
  setEditingEnabled,
  onToggleEditModal,
  onToggleEditModalTab,
  onToggleMessageSending,
  profile
}) => {
  const adminMenu = () => {
    const editDropdown = () => {
      if (profile?.permissions?.canAdminister || profile?.permissions?.canEdit) {
        return (
          <li className="dropdown" id="adminlink">
            <a
              aria-expanded="false"
              aria-haspopup="true"
              role="button"
              data-toggle="dropdown"
              className="dropdown-toggle"
              href="#">
              {t`Administer`} <span className="caret"></span>
            </a>
            <ul className="dropdown-menu">
              <li>
                <a onClick={() => setEditingEnabled(!editingEnabled)}>
                  {editingEnabled ? t`Disable Editing` : t`Enable Editing`}
                </a>
              </li>
              <li>
                <a
                  onClick={() => dispatch(openCContentWizard_(profile.id, profile.type))}>
                  {t`Add Section`}
                </a>
              </li>
              <li>
                <a
                  onClick={() => dispatch(openCFileWizard_(profile, profile.type))}
                  href="#">
                  {t`Manage Files`}
                </a>
              </li>
              <li>
                <a
                  onClick={() =>
                    onToggleEditModalTab(profile.type, profile.id, 1).then(() =>
                      onToggleEditModal(true, profile)
                    )}
                  className="editprofile"
                  href="#">
                  {t`Edit Profile`}
                </a>
              </li>
              <li>
                <a
                  onClick={() => dispatch(loadSurveys(profile.type, profile.id, true))}
                  className="surveyLink"
                  href="#">
                  {t`Manage Surveys`}
                </a>
              </li>
              <li>
                <a onClick={() => dispatch(openCollection('profileadmin'))}>{t`Help`}</a>
              </li>
              {dynamicValues.userProfile?.hasAdmin && (
                <li>
                  <a onClick={() => dispatch(togglePromotion(profile))}>
                    {t`Toggle Promotion`} {profile.promoted ? t`OFF` : t`ON`}
                  </a>
                </li>
              )}
            </ul>
          </li>
        )
      }
    }
    const statsDropdown = () => {
      if (
        profile.hasOwnProperty('permissions') &&
        (profile.permissions.canAdminister || profile.permissions.canViewReports)
      ) {
        return (
          <li>
            <Link to={`/profiles/${profile.type}/${profile.id}/stats`}>
              {t`Statistics`}
            </Link>
          </li>
        )
      }
    }

    if (
      profile.hasOwnProperty('permissions') &&
      (profile.permissions.canAdminister ||
        profile.permissions.canEdit ||
        profile.permissions.canViewReports)
    ) {
      return (
        <div className="row" id="admin-menu">
          <nav className="navbar navbar-right">
            <ul className="navbar navbar-nav">
              <li className="active">
                <Link to={`/profiles/${profile.type}/${profile.id}`}>{t`Main`}</Link>
              </li>
              {statsDropdown()}
              {editDropdown()}
            </ul>
          </nav>
        </div>
      )
    }
  }
  const addBgImage = () => {
    if (profile.headerImage) {
      return {
        backgroundImage: `url('${profile.headerImage}')`
      }
    }

    if (profile.type === 'company') {
      return {
        backgroundImage: `url('/images/headed2/new/localopportunities/H2-Profile-Mastheads-0520-v1_Company.svg')`
      }
    }

    if (profile.type === 'certification') {
      return {
        backgroundImage: `url('/images/headed2/new/localopportunities/H2-Mastheads-0520-v1_Certification.svg')`
      }
    }

    return {}
  }
  const title = () => {
    const defaultLogoTypeImgs = () => {
      if (profile.logo) {
        return profile.logo
      }

      switch (profile.type) {
        case 'program':
          return program
        case 'institution':
          return college
        case 'certification':
          return certification
        case 'offeringtype':
          return workBasedLearning
        default:
          return companies
      }
    }

    return [
      <a href={profile.url} rel="nofollow" target="_self" id="logo">
        <img
          src={defaultLogoTypeImgs()}
          alt={t`Logo for ${profile.title}`}
          className={profile.stylizeLogo ? 'logo' : 'logo-unstyled'}
        />
      </a>,
      <div className="profile-title-box">{profile.title}</div>
    ]
  }
  const userButton = () => {
    if (profile.type === 'user' && profile.hasOwnProperty('personalizedUrl')) {
      return (
        <div id="messaging">
          <button
            id="message"
            className="btn btn-submit small"
            onClick={() =>
              onToggleMessageSending(profile.personalizedUrl, profile.firstName)}>
            <span>
              <i className="fal fa-comment" aria-hidden="true"></i> {t`Send Message`}
            </span>
          </button>
        </div>
      )
    }

    return null
  }
  const wrapIfParent = hdr => {
    if (profile.type == 'offeringtype') {
      return (
        <div id="profile-parent">
          <div id="parent-info">
            <Link to={`/opportunities`} id="logo">
              <img
                src={workBasedLearning}
                alt={t`Logo for work based learning`}
                className={'logo'}
              />
              &#160;
              {t`Local Opportunities Hub`}
            </Link>
          </div>
          {hdr}
        </div>
      )
    }

    if (profile.hasOwnProperty('parent')) {
      return (
        <div id="profile-parent">
          <div id="parent-info">
            {profile.parent.logo ? (
              <Link to={profile.parent.url} id="logo">
                <img
                  src={profile.parent.logo}
                  alt={t`Logo for ${profile.parent.title}`}
                  className={profile.parent.stylizeLogo ? 'logo' : 'logo-unstyled'}
                />
                &#160;
                {profile.parent.title}
              </Link>
            ) : (
              <Link to={profile.parent.url} target="_self">
                {profile.parent.title}
              </Link>
            )}
          </div>
          {hdr}
        </div>
      )
    }

    return hdr
  }

  return wrapIfParent(
    <div
      id="profile-info"
      style={addBgImage()}
      className={`with-border ${profile.headerImage ? 'with-image' : 'without-image'}`}>
      {userButton()}
      {adminMenu()}
      {title()}
      <div id="other"></div>
    </div>
  )
}
const isDisabled = (profile, toggleActive) => {
  if (!profile.active) {
    const btn = (
      <a
        className="btn btn-gray no-style pull-right"
        onClick={() => {
          toggleActive(profile.type, profile.id)
        }}>
        {t`Activate Now`}
      </a>
    )

    return (
      <div className="alert alert-warning">
        <div className="row">
          <div className="col-xs-12">{jt`This profile is disabled, you are seeing it because you are an administrator. ${btn}`}</div>
        </div>
      </div>
    )
  }

  return null
}
const ProfileContainer = props => {
  const params = useParams()

  useEffect(() => {
    props.dispatch(loadProfile(params.profileType, params.profileId))
  }, [params.profileType, params.profileId, props.signedIn])

  if (props.isLoading) {
    return <LoadingIndicator newSiteLook={true} />
  }

  if (!props.profile || !props.profile.type) {
    return <h3>{t`Could not load requested profile`}</h3>
  }

  return (
    <div id="customizable-profile" className={`container profile-${props.profile.type}`}>
      {isDisabled(props.profile, props.toggleActive)}
      <CSSTransitionGroup
        component="div"
        transitionName={'h2animate'}
        transitionEnterTimeout={400}
        transitionLeaveTimeout={400}>
        {React.cloneElement(
          <div>
            <ProfileHeader
              {...props}
              setEditingEnabled={props.setEditingEnabled}
              editingEnabled={props.editingEnabled}
            />
            {props.children}
          </div>,
          { key: props.profile?.id }
        )}
      </CSSTransitionGroup>

      <Modal
        bsSize="large"
        backdrop="static"
        show={props.surveyEdit.modalOpen}
        onHide={props.onDismissSurveyModal}>
        <Modal.Header closeButton>
          <h2>{t`Surveys`}</h2>
        </Modal.Header>
        <Modal.Body>
          <SurveyListModal
            surveys={props.surveyEdit.data}
            selected={props.surveyEdit.forEdit}
            selectedQuestion={props.surveyEdit.selectedQuestion}
            unselectForEdit={props.onUnselectSurveyForEdit}
            selectForEdit={props.onSelectSurveyForEdit}
            onCreateNewSurvey={props.onCreateNewSurvey}
            onMoveQuestion={props.onMoveQuestion}
            onSelectSurveyToRename={props.onSelectSurveyToRename}
            renameTitleActive={!!props.surveyEdit.originalTitle}
            onRenameSurvey={props.onRenameSurvey}
            onCancelRenameSurvey={props.onCancelRenameSurvey}
            onSelectQuestion={props.onSelectQuestion}
            onDeleteQuestion={props.onDeleteQuestion}
            handleSurveyNameChange={props.handleSurveyNameChange}
            onSaveQuestion={props.onSaveQuestion}
            onSaveSurvey={props.onSaveNewSurvey(props.profile.type, props.profile.id)}
            onClone={props.onSurveyClone(props.profile.type, props.profile.id)}
          />
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        backdrop="static"
        show={props.userSurveyModalOpen}
        onHide={props.onCloseSurvey}>
        <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={props.onCloseSurvey}>
            <span aria-hidden="true">×</span>
          </button>
          <Modal.Title>{props.survey ? props.survey.name : <h2>Survey</h2>}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ padding: '15px' }}>
            <OutputSurvey
              onSubmitSurvey={props.onSubmitSurvey(props.survey)}
              showTitle={false}
              validateResponse={props.onValidateSurvey}
              survey={props.survey}
              onSurveyCancel={props.onCloseSurvey}
              response={props.surveyResponse}
              onRespond={props.onRespondSurveyQuestion(props.survey)}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        backdrop="static"
        show={
          !props.profile.setup &&
          props.profile.hasOwnProperty('permissions') &&
          (props.profile.permissions.canAdminister || props.profile.permissions.canEdit)
        }
        onHide={props.onHideModal}>
        <Modal.Header>
          <h2>Profile Setup</h2>
        </Modal.Header>
        <Modal.Body>
          <ProfileSetupWizard
            profile={props.profile}
            modalCloseAction={props.onHideModal}
            profileUpdateAction={props.onSetupProfile}
          />
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        backdrop="static"
        show={props.editModalOpen}
        onHide={() => props.onToggleEditModal(false)}>
        <Modal.Header closeButton>
          <h2>{t`Edit Profile`}</h2>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            activeKey={props.selectedEditPanel}
            onSelect={_onToggleEditModalTab(
              props.profile.type,
              props.profile.id,
              props.onToggleEditModalTab
            )}
            id="controlled-tab-example"
            mountOnEnter={true}
            unmountOnExit={true}>
            <Tab eventKey={1} title={t`Edit Content`}>
              <div style={{ marginTop: '20px' }}>
                <EditForm
                  profile={props.profile}
                  clusterSuggestions={props.clusterSuggestions}
                  tagSuggestions={props.tagSuggestions}
                  onSearchClusters={props.onSearchClusters}
                  onSearchTags={props.onSearchTags}
                  profileEditError={props.profileEditError}
                  saveAction={props.onSaveProfile(props.profile.type, props.profile.id)}
                  cancelAction={() => props.onToggleEditModal(false)}
                />
              </div>
            </Tab>
            <Tab eventKey={3} title={t`Permissions`}>
              <div style={{ marginTop: '20px' }}>
                <PermissionModal
                  permissions={props.permissions.data}
                  onToggleUserPermission={props.onToggleUserPermission(
                    props.profile.type,
                    props.profile.id
                  )}
                  onDeletePermission={props.onDeleteUserPermissions(
                    props.profile.type,
                    props.profile.id
                  )}
                  onAddUser={props.onAddUserPermission(
                    props.profile.type,
                    props.profile.id
                  )}
                />
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        backdrop="static"
        show={props.help.modalOpen}
        onHide={props.onCloseDocumentation}>
        <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={props.onCloseDocumentation}>
            <span aria-hidden="true">×</span>
          </button>
          <h2>{props.help.collection.name}</h2>
        </Modal.Header>
        <Modal.Body>
          <div style={{ padding: '15px' }}>
            <Documentation
              collection={props.help.collection}
              showSide={true}
              selectedSection={
                props.help.selectedSection
                  ? props.help.collection.sections.find(
                      s => s.id === props.help.selectedSection
                    )
                  : (props.help.collection.sections || [])[0] || {}
              }
              selectSection={props.onSelectDocumentationSection}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
const _onToggleEditModalTab = (t, p, fn) => pId => {
  return fn(t, p, pId)
}
const dispatchToProps = dispatch => ({
  dispatch,
  toggleActive: (profileType, profileId) =>
    dispatch(toggleActive(profileType, profileId)),
  onToggleDrag: s => dispatch(toggleDrag(s)),
  onCloseDocumentation: () => dispatch(closeDocumentationModal()),
  onSelectDocumentationSection: s => dispatch(selectSection(s)),
  onDeleteSection: (profileType, profileId, sectionId) =>
    dispatch(deleteSection(profileType, profileId, sectionId)),
  onHideModal: () => dispatch(closeSetupModal()),
  onSetupProfile: (profileType, profileId, data) =>
    dispatch(finishProfileSetup(profileType, profileId, data)),
  onDismissPermissions: () => dispatch(dismissPermissions()),
  onCloseSurvey: () => dispatch(closeSurveyModal()),
  onDismissSurveyModal: () => dispatch(dismissEditSurveyModal()),
  onToggleMessageSending: (name, firstName) =>
    dispatch(
      openMessageDialog({
        firstName,
        name
      })
    ),
  onSearchClusters: () => dispatch(searchClusters()),
  onSearchTags: (profileType, profileId) => dispatch(searchTags(profileType, profileId)),
  onSaveNewSurvey: (profileType, profileId) => values =>
    dispatch(saveNewProfileSurvey(profileType, profileId, values)),
  onCreateNewSurvey: () => dispatch(createNewSurveyForEdit()),
  onSelectSurveyForEdit: surveyId => dispatch(selectSurveyForEdit(surveyId)),
  onSaveProfile: (profileType, profileId) => values =>
    dispatch(saveProfileUpdates(profileType, profileId, values)).then(() =>
      dispatch(toggleEditModal(false))
    ),
  onUnselectSurveyForEdit: () => dispatch(unselectSurveyForEdit()),
  onSurveyClone: (profileType, profileId) => surveyId =>
    dispatch(cloneProfileSurveyAction(profileType, profileId, surveyId)),
  onToggleUserPermission:
    (profileType, profileId) => (permissionId, permissionType, enabled) => {
      console.log(profileType, profileId, permissionId, permissionType, enabled)
      dispatch(
        toggleUserPermission(
          profileType,
          profileId,
          permissionId,
          permissionType,
          enabled
        )
      )
    },
  onToggleEditModal: (s, profile) => dispatch(toggleEditModal(s, profile)),
  onToggleEditModalTab: (profileType, profileId, s) =>
    dispatch(selectEditModalTab(profileType, profileId, s)),
  onDeleteUserPermissions: (profileType, profileId) => permissionId =>
    dispatch(deleteUserPermission(profileType, profileId, permissionId)),
  onAddUserPermission: (profileType, profileId) => data =>
    dispatch(addUserPermission(profileType, profileId, data)),
  onReorder: (profileType, profileId, draggableId, json) => {
    dispatch(reorder(profileType, profileId, draggableId, json))
  },
  onSelectSurveyToRename: surveyId => {
    dispatch(selectForRename(surveyId))
  },
  onRenameSurvey: surveyId => {
    dispatch(doRename(surveyId))
  },
  handleSurveyNameChange: v => {
    dispatch(updateSurveyName(v.target.value))
  },
  onMoveQuestion: (surveyId, questionId, targetPosition) => {
    //  (selected.id, result.draggableId, result.destination.index),
    dispatch(reorderQuestion(surveyId, questionId, targetPosition))
  },
  onSaveQuestion: (survey, question) => {
    dispatch(saveQuestion(survey, question))
  },
  onSelectQuestion: questionId => {
    dispatch(selectSurveyQuestionForEdit(questionId))
  },
  onDeleteQuestion: (surveyId, questionId) => {
    dispatch(deleteSurveyQuestion(surveyId, questionId))
  },
  onSubmitSurvey: survey => form => {
    dispatch(submitSurvey(survey, form)).then(() => dispatch(closeSurveyModal()))
  },
  onCancelRenameSurvey: () => {
    dispatch(cancelRename())
  },
  onValidateSurvey: (question, response) => {
    return dispatch(validateResponse(question, response))
  },
  onRespondSurveyQuestion: survey => (question, response, allowMulti, isAddition) => {
    dispatch(respondToQuestion(survey, question, response, allowMulti, isAddition))
  }
})
const stateToProps = state => {
  const signedIn = !!state.authenticationState.userProfile

  return {
    signedIn,
    ...state.profileView,
    ...state.surveys,
    surveyEdit: state.surveyEdit,
    help: state.documentation
  }
}

export default connect(stateToProps, dispatchToProps)(ProfileContainer)
